// @ts-nocheck
(function () {
  var INITIAL_VISIBLE = 6;

  function initSection(section) {
    var grid = section.querySelector('.smg-reviews-grid__grid');
    var btnWrapper = section.querySelector('.smg-reviews-grid__load-more');
    if (!grid || !btnWrapper) return;

    var cards = Array.from(grid.querySelectorAll('.smg-reviews-grid__card'));

    // Nothing to load — keep button hidden
    if (cards.length <= INITIAL_VISIBLE) {
      btnWrapper.setAttribute('aria-hidden', 'true');
      return;
    }

    // Hide cards beyond the initial count
    for (var i = INITIAL_VISIBLE; i < cards.length; i++) {
      cards[i].classList.add('smg-reviews-grid__card--hidden');
    }

    // Show the Load More button
    btnWrapper.removeAttribute('aria-hidden');

    var btn = btnWrapper.querySelector('.smg-reviews-grid__load-more-btn');
    if (!btn) return;

    btn.addEventListener('click', function () {
      cards.forEach(function (card) {
        card.classList.remove('smg-reviews-grid__card--hidden');
      });
      btnWrapper.setAttribute('aria-hidden', 'true');
    });
  }

  function init() {
    document.querySelectorAll('.smg-reviews-grid').forEach(function (section) {
      initSection(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector
      ? e.target.querySelector('.smg-reviews-grid') || e.target.closest('.smg-reviews-grid')
      : null;
    if (section) initSection(section);
  });
})();
